<ion-app>
  <div class="responsive-app-container" [ngClass]="{'full-width': allowFullScreen}">
    <div class="page-container " *ngIf="isReady && appDisabled">
      <div class="layout-page-container">
        <ion-row class="layout-title-spacer">
          <ion-col>
            <div class="layout-title-spacer"></div>
          </ion-col>
        </ion-row>
        <ion-row class="layout-title-spacer">
          <ion-col class="layout-page-logo ">
            <ion-img src="assets/v2/images/vivascore-v.svg"></ion-img>
          </ion-col>
        </ion-row>
        <ion-row class="layout-title-spacer">
          <ion-col>
            <h1>{{'home-page.update.udpate-required' | translate}}</h1>
            <p>{{'home-page.update.update-message' | translate}}</p>
            <ion-button (click)="updateApp()">{{'home-page.update.update-button' | translate}}</ion-button>
          </ion-col>
        </ion-row>
      </div>
    </div>

    <div class="update-nudge" *ngIf="isReady && updateAvailable" (click)="updateApp()">
      <span>{{'home-page.update.update-app-minor' | translate}}</span>
    </div>

    <ion-content *ngIf="isReady && !appDisabled">
      <div class="layout-busy-spinner" *ngIf="busyLoading">
        <viva-spinner color="var(--ion-text-color)"></viva-spinner>
      </div>
      <div class="ai-chat-icon" *ngIf="chatRouteAllowed && chatAllowed" (click)="aiChatClicked()">
        <ion-img src="assets/v3/viva-bot-default.svg"></ion-img>
      </div>

      <app-main-menu></app-main-menu>
      <ion-router-outlet id="main-content" class="background-blur-target">
      </ion-router-outlet>
    </ion-content>

  </div>



</ion-app>